var _excluded = ["suburb", "status", "propertytypes", "beds", "district", "region", "street", "postcode", "school"],
  _excluded2 = ["suburb", "status", "district", "region"],
  _excluded3 = ["filters"],
  _excluded4 = ["divisionId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { includes, isEmpty } from 'lodash';
import queryString from 'qs';
import { ListingType, LocalityType, PropertyType, LocalityTypeName } from '@domain-group/fe-allhomes-library/lib/node';
import { isA } from '../utils/testing';
import { Filters } from './filters';
import { pathParametersToListingType } from '../utils/parse-listing-type';
import { SortOrder } from './fields/sort-order';
import { Page } from './fields/page';
import { PageSize } from './fields/page-size';
import { Results } from './fields/results';
import { parseSearchType } from '../enums/search-type';
import { parseSearchOptions } from './search-options';
import { newListingsPageTypeFromSearchType } from '../enums/new-listings-page-type';
export var SearchQueryFields = ['sort', 'page', 'pageSize', 'results'];
var isSearchQueryArgObj = filtersOrInputObject => filtersOrInputObject ? 'filters' in filtersOrInputObject : false;
export class SearchQuery {
  constructor(listingType, filtersOrInputObject, options) {
    _defineProperty(this, "filters", void 0);
    _defineProperty(this, "sort", void 0);
    _defineProperty(this, "page", void 0);
    _defineProperty(this, "pageSize", void 0);
    _defineProperty(this, "results", void 0);
    var divisionId = filtersOrInputObject && 'divisionId' in filtersOrInputObject && filtersOrInputObject.divisionId;
    var searchOptions = parseSearchOptions({
      listingType: typeof listingType === 'object' ? listingType.name : listingType,
      searchType: (options === null || options === void 0 ? void 0 : options.searchType) || (filtersOrInputObject && 'searchType' in filtersOrInputObject ? filtersOrInputObject.searchType : undefined)
    });
    var values = SearchQuery.isInstance(filtersOrInputObject) ? filtersOrInputObject.getValues() : filtersOrInputObject;
    var _ref = isSearchQueryArgObj(values) ? values : _objectSpread({
        filters: values
      }, options),
      filters = _ref.filters,
      sort = _ref.sort,
      page = _ref.page,
      pageSize = _ref.pageSize,
      results = _ref.results;
    var filtersInstance = new Filters(searchOptions, filters);
    this.sort = new SortOrder(searchOptions, sort);
    this.page = new Page(searchOptions, page);
    this.pageSize = new PageSize(searchOptions, pageSize);
    this.results = new Results(searchOptions, results);
    this.filters = divisionId ? filtersInstance.cloneWithLocalities([{
      type: LocalityType.DIVISION.type,
      id: divisionId
    }]) : filtersInstance;
    this.isMapSearch = this.isMapSearch.bind(this);
  }
  getLocalities() {
    return this.filters.getLocalities();
  }
  getSingleLocality() {
    return this.filters.getSingleLocality();
  }
  resolveLocalities(localityMap, removeMissing) {
    return this.filters.resolveLocalities(localityMap, removeMissing);
  }
  getBounds() {
    return this.filters.getBounds();
  }
  isSold() {
    return this.filters.isSold();
  }
  isRented() {
    return this.filters.isRented();
  }
  toQueryObject() {
    var filters = this.filters.toQueryObject();
    return _objectSpread(_objectSpread(_objectSpread({}, Object.fromEntries(SearchQueryFields.map(field => [field, this[field].getCondensedValue()]).filter(_ref2 => {
      var _ref3 = _slicedToArray(_ref2, 2),
        value = _ref3[1];
      return value != null;
    }))), isEmpty(filters) ? {} : {
      filters
    }), this.searchType === 'normal' ? {} : {
      searchType: this.searchType
    });
  }
  get listingType() {
    return this.filters.listingType;
  }
  get searchType() {
    return this.filters.searchType;
  }
  isMapSearch() {
    return this.results.isMapSearch();
  }
  isListSearch() {
    return this.results.isListSearch();
  }
  isDefault() {
    return this.filters.isDefault();
  }
  isNewListings() {
    return this.searchType === 'new-listings' || this.searchType === 'strict-new-listings';
  }
  isBroadSearch() {
    var moreSpecificLocality = this.filters.getLocalities().find(locality => !includes([LocalityTypeName.DISTRICT, LocalityTypeName.REGION, LocalityTypeName.POSTCODE], locality.type));
    return this.filters.isLocationEmpty() || !moreSpecificLocality;
  }
  getSortUrl() {
    return this.sort.getUrlParameterValue();
  }
  toUrlParameters() {
    return [...this.sort.toUrlParameters(), ...this.page.toUrlParameters(), ...this.pageSize.toUrlParameters(), ...this.results.toUrlParameters(), ...this.filters.toUrlParameters()].filter(each => each != null);
  }
  getValues() {
    var values = _objectSpread(_objectSpread({}, Object.fromEntries(SearchQueryFields.map(field => [field, this[field].value]))), {}, {
      filters: this.filters.getValues(),
      searchType: this.searchType
    });
    return values;
  }
  isSearchQuery() {
    return true;
  }
  isIndexable() {
    var url = this.toSearchUrl();
    var _url$split = url.split('?'),
      _url$split2 = _slicedToArray(_url$split, 2),
      _urlBase = _url$split2[0],
      searchParams = _url$split2[1];
    return !(searchParams || '').split('&').filter(each => each.length > 0).map(each => each.split('=')[0]).some(each => each.toLowerCase() !== 'page');
  }
  toSearchUrl() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      searchType = _ref4.searchType,
      pageTemplate = _ref4.pageTemplate;
    var newListingsPageType = newListingsPageTypeFromSearchType(parseSearchType(searchType, this.searchType));
    return newListingsPageType ? this.buildNewListingsUrl({
      pageTemplate,
      pageType: newListingsPageType
    }) : this.buildSearchUrl({
      pageTemplate
    });
  }
  buildSearchUrl() {
    var _this$filters$beds, _this$filters$propert;
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      pageTemplate = _ref5.pageTemplate;
    var isResiSold = this.isSold() && this.listingType === ListingType.SALES_RESIDENTIAL.name;
    var _this$toUrlParameters = this.toUrlParameters().reduce((obj, param) => _objectSpread(_objectSpread({}, obj), param), {}),
      suburb = _this$toUrlParameters.suburb,
      status = _this$toUrlParameters.status,
      propertytypes = _this$toUrlParameters.propertytypes,
      beds = _this$toUrlParameters.beds,
      district = _this$toUrlParameters.district,
      region = _this$toUrlParameters.region,
      street = _this$toUrlParameters.street,
      postcode = _this$toUrlParameters.postcode,
      school = _this$toUrlParameters.school,
      otherParams = _objectWithoutProperties(_this$toUrlParameters, _excluded);
    var localities = {
      suburb,
      district,
      region,
      street,
      postcode,
      school
    };
    var singleLocality = this.getSingleLocality();
    var useSingleLocality = !this.filters.localities.isDefault() && singleLocality && singleLocality.slug && ('newListingsSlug' in singleLocality || 'type' in singleLocality && singleLocality.type === LocalityType.DIVISION.type);
    var singleBeds = useSingleLocality && ((_this$filters$beds = this.filters.beds) === null || _this$filters$beds === void 0 ? void 0 : _this$filters$beds.getSingleValue());
    var singlePropertyType = useSingleLocality && ((_this$filters$propert = this.filters.propertyTypes) === null || _this$filters$propert === void 0 ? void 0 : _this$filters$propert.getSingleValue());
    var params = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, !useSingleLocality && localities), !isResiSold && status && {
      status
    }), otherParams), !singlePropertyType && propertytypes && {
      propertytypes
    }), !singleBeds && beds && {
      beds
    }), pageTemplate ? {
      page: pageTemplate
    } : {});
    var paramList = queryString.stringify(params, {
      encode: false
    });
    var queryParam = paramList ? "?".concat(paramList) : '';
    var searchType = isResiSold ? 'sold' : ListingType[this.filters.listingType].urlContext;
    var urlParts = [searchType, useSingleLocality ? singleLocality.slug : 'search', ...(singlePropertyType ? [PropertyType[singlePropertyType].urlSlug] : []), ...(singleBeds ? ["".concat(singleBeds, "-bedrooms")] : [])];
    var baseUrl = urlParts.join('/');
    return "/".concat(baseUrl).concat(useSingleLocality ? '/' : '').concat(queryParam);
  }
  toNewListingsUrl() {
    var pageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'new-listings';
    if (pageType !== 'new-listings' && pageType !== 'new-price') {
      throw new Error("Invalid pageType: ".concat(pageType));
    }
    return this.buildNewListingsUrl({
      pageType
    });
  }
  buildNewListingsUrl() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      pageType = _ref6.pageType,
      pageTemplate = _ref6.pageTemplate;
    var searchType = ListingType[this.filters.listingType].urlContext;
    var singleLocality = this.getSingleLocality();
    if (!singleLocality) {
      throw new Error("New Listings/Price URL only works for single localities, localities were: ".concat(JSON.stringify(this.filters.localities)));
    }
    var reducedParams = this.toUrlParameters().reduce((obj, param) => _objectSpread(_objectSpread({}, obj), param), {});
    var suburb = reducedParams.suburb,
      status = reducedParams.status,
      district = reducedParams.district,
      region = reducedParams.region,
      params = _objectWithoutProperties(reducedParams, _excluded2);
    var baseUrl = "/".concat(searchType, "/").concat('newListingsSlug' in singleLocality ? singleLocality.newListingsSlug : singleLocality.slug);
    var paramsWithPage = pageTemplate ? _objectSpread(_objectSpread({}, params), {}, {
      page: pageTemplate
    }) : params;
    var queryParam = isEmpty(paramsWithPage) ? '' : "?".concat(queryString.stringify(paramsWithPage, {
      encode: false
    }));
    return "".concat(baseUrl, "/").concat(pageType, "/").concat(queryParam);
  }
  cloneWith() {
    var newValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var filters = newValues.filters,
      queryValues = _objectWithoutProperties(newValues, _excluded3);
    var updatedObject = _objectSpread(_objectSpread(_objectSpread({}, this.getValues()), queryValues), {}, {
      filters: this.filters.cloneWith(filters).getValues()
    });
    return new SearchQuery(this.listingType, updatedObject);
  }
  cloneWithLocalities(localities) {
    return this.cloneWith({
      filters: {
        localities
      }
    });
  }
  static isInstance(value) {
    return isA(value, 'SearchQuery');
  }
  static valuesOf(obj) {
    return SearchQuery.isInstance(obj) ? obj.getValues() : obj || {};
  }
  static toQueryObject(queryOrObject) {
    return SearchQuery.isInstance(queryOrObject) ? queryOrObject.toQueryObject() : queryOrObject;
  }
  static fromPossibleQueryObject(listingType, queryOrObject) {
    return SearchQuery.isInstance(queryOrObject) ? queryOrObject : SearchQuery.fromQueryObject(listingType, queryOrObject);
  }
  static fromQueryObject(listingType, input) {
    var divisionId = input.divisionId,
      body = _objectWithoutProperties(input, _excluded4);
    return new SearchQuery(listingType, {
      filters: body.filters,
      sort: body.sort,
      pageSize: body.pageSize,
      page: body.page,
      results: body.results,
      searchType: body.searchType,
      divisionId
    });
  }
  static fromUrlParameters(listingTypeOrPathParameters, queryParameters, pathParameters) {
    var _SortOrder$fromUrlPar, _Page$fromUrlParamete, _Results$fromUrlParam;
    var _ref7 = typeof listingTypeOrPathParameters === 'string' ? [listingTypeOrPathParameters, queryParameters, pathParameters] : [pathParametersToListingType(listingTypeOrPathParameters === null || listingTypeOrPathParameters === void 0 ? void 0 : listingTypeOrPathParameters.listingType), queryParameters, listingTypeOrPathParameters],
      _ref8 = _slicedToArray(_ref7, 3),
      listingType = _ref8[0],
      _ref8$ = _ref8[1],
      queryParams = _ref8$ === void 0 ? {} : _ref8$,
      _ref8$2 = _ref8[2],
      pathParams = _ref8$2 === void 0 ? {} : _ref8$2;
    var searchOptions = parseSearchOptions({
      listingType,
      searchType: pathParams.searchType
    });
    return new SearchQuery(searchOptions.listingType, {
      filters: Filters.fromUrlParameters(searchOptions, queryParams, pathParams).getValues(),
      sort: (_SortOrder$fromUrlPar = SortOrder.fromUrlParameters(searchOptions, queryParams)) === null || _SortOrder$fromUrlPar === void 0 ? void 0 : _SortOrder$fromUrlPar.value,
      page: (_Page$fromUrlParamete = Page.fromUrlParameters(searchOptions, queryParams)) === null || _Page$fromUrlParamete === void 0 ? void 0 : _Page$fromUrlParamete.value,
      results: (_Results$fromUrlParam = Results.fromUrlParameters(searchOptions, queryParams)) === null || _Results$fromUrlParam === void 0 ? void 0 : _Results$fromUrlParam.value,
      searchType: searchOptions.searchType
    });
  }
}